<template>
  <div class="bar p-x-20 remove-margin">
    <div class="keterangan d-flex-between remove-margin">
      <div class="f-14 f-regular f-c-primary p-t-16 remove-margin">
        <div class="f-18 f-c-midgrey remove-margin">
          <p>
            Terimakasih telah memesan app konsumen whitelabel.
            paket pemesanan anda  <span class="f-bold">{{
		          detailPesanan.whitelabel_jenis.nama
	          }}</span> dengan harga
            <span class="f-bold">
              Rp {{ formatRupiah(detailPesanan.tagihan) }}</span
            > yang dapat dibayar {{detailPesanan.whitelabel_jenis.cicilan_kali}} Kali selama  {{detailPesanan.whitelabel_jenis.cicilan_kali}} bulan
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-around">
      <div class="terbayar text-alignC">
        <p class="f-c-midgrey remove-margin">Terbayar</p>
        <b>Rp {{ formatRupiah(detailPesanan.terbayar) }}</b>
      </div>
      <div class="totalcicil text-alignC">
        <p class="f-c-midgrey remove-margin">Sisa cicilan</p>
        <b>{{ detailPesanan.sisa_cicilan }} Cicilan</b>
      </div>
    </div>
    <div class="separator m-x-min m-d-20" />
    <div class="card-scroll-container">
      <div class="card-container p-d-20">
        <template
          v-for="(cardCicilan, index) in detailPesanan.whitelabel_cicilan"
        >
          <CardCicilan
            v-if="cardCicilan.status !== '10_lunas'"
            :status="cardCicilan.status"
            :cicilan_ke="cardCicilan.cicilan_ke"
            :cicilan_tagihan="cardCicilan.cicilan_tagihan"
            :expired_at="cardCicilan.expired_at"
            :key="index"
            :idCicilan="cardCicilan.id"
            :data="cardCicilan"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CardCicilan from "@/modules/whitelabel/components/cardcicilan";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";
export default {
  name: "Cicilan",
  components: {
    CardCicilan,
  },
  async mounted() {
    await this.init();
  },
  computed: {
    ...mapGetters(moduleName, {
      detailPesanan: "detailPesanan",
      whitelabel: "whitelabel",
    }),
  },

  methods: {
    ...mapActions(moduleName, { getDetail: `${moduleName}/getDetail` }),
    async init() {
      await this.getDetail();
    },
  },
};
</script>

<style scoped>
.trainingList .separator {
  width: unset;
  height: 15px;
}

.bar {
  margin-top: auto;
  margin-bottom: auto;
}
</style>
